import React from 'react';
import { Typography, useMediaQuery, CircularProgress, Stack, Button, Box, Paper } from '@mui/material';
import { ArrowRightOutlined } from '@ant-design/icons';
import FeedbackButtons from 'components/FeedbackButtons';

const SegmentationSection = ({
  segmentation,
  isProUser,
  handleTrialClick,
  handleScrollToICP,
  taskId,
  analysisData,
  hoveredItems,
  setHoveredItems
}) => {
  const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <div
      id="segmentation"
      onMouseEnter={() => setHoveredItems((prev) => ({ ...prev, 'audience-segmentation': true }))}
      onMouseLeave={() => setHoveredItems((prev) => ({ ...prev, 'audience-segmentation': false }))}
    >
      <Stack mt={5} spacing={2} direction="row" alignItems="center" justifyContent="center">
        <Typography variant="h3" align="center">
          Audience segmentation
        </Typography>
        {!segmentation && <CircularProgress size={24} />}
      </Stack>
      {segmentation !== null && segmentation.Segments?.length > 0 && (
        <Stack mt={2}>
          {/* Show first segment for all users */}
          {segmentation.Segments.slice(0, 1).map((segment, index) => (
            <React.Fragment key={index}>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="h4" my={2} align="left" id={`segmentation-${segment.name.toLowerCase().replace(/\s+/g, '_')}`}>
                  {segment.name}
                </Typography>
                <Button
                  variant="text"
                  color="primary"
                  endIcon={<ArrowRightOutlined />}
                  sx={{ fontWeight: 'normal' }}
                  onClick={() => handleScrollToICP(segment.name)}
                >
                  To Segment ICP
                </Button>
              </Stack>
              <Typography variant={matchDownSM ? 'body2' : 'body1'}>{segment.description}</Typography>
            </React.Fragment>
          ))}

          {/* Show remaining segments only for paid users */}
          {isProUser &&
            segmentation.Segments.slice(1).map((segment, index) => (
              <React.Fragment key={index + 1}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography variant="h4" my={2} align="left" id={`segmentation-${segment.name.toLowerCase().replace(/\s+/g, '_')}`}>
                    {segment.name}
                  </Typography>
                  <Button
                    variant="text"
                    color="primary"
                    endIcon={<ArrowRightOutlined />}
                    sx={{ fontWeight: 'normal' }}
                    onClick={() => handleScrollToICP(segment.name)}
                  >
                    To Segment ICP
                  </Button>
                </Stack>
                <Typography variant={matchDownSM ? 'body2' : 'body1'}>{segment.description}</Typography>
              </React.Fragment>
            ))}

          {/* Show CTA for free users */}
          {!isProUser && (
            <Box mt={0} sx={{ position: 'relative', overflow: 'hidden', minHeight: '550px' }}>
              <Box
                sx={{
                  filter: 'blur(5px)',
                  userSelect: 'none',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  padding: 0
                }}
              >
                {segmentation.Segments.slice(1).map((segment, index) => (
                  <React.Fragment key={index + 1}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Typography variant="h4" my={2} align="left" id={`segmentation-${segment.name.toLowerCase().replace(/\s+/g, '_')}`}>
                        {segment.name}
                      </Typography>
                      <Button variant="text" color="primary" endIcon={<ArrowRightOutlined />} sx={{ fontWeight: 'normal' }}>
                        Go to Segment ICP
                      </Button>
                    </Stack>
                    <Typography variant={matchDownSM ? 'body2' : 'body1'} align="left">
                      {segment.description}
                    </Typography>
                  </React.Fragment>
                ))}
              </Box>
              <Paper
                elevation={3}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: 2,
                  backdropFilter: 'blur(5px)',
                  backgroundColor: 'rgba(255, 255, 255, 0.6)',
                  textAlign: 'center'
                }}
              >
                <Typography variant="h5" color="primary" align="center" mb={1}>
                  Start your FREE 7 days trial to get access to all Audience Segments!
                </Typography>
                {/* <Typography variant="h5" color='primary' align="center" mb={1}>
                                  Upgrade to Pro to get access to all Audience Segments!
                              </Typography> */}

                <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleTrialClick}>
                  Unlock Audience Segments
                </Button>
              </Paper>
            </Box>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
            <FeedbackButtons
              blockId="audience-segmentation"
              blockType="audience-segmentation"
              blockTitle="Audience Segmentation"
              blockContent={JSON.stringify(segmentation)}
              taskId={taskId}
              serviceName={analysisData['Service Name']}
              isVisible={!!hoveredItems['audience-segmentation']}
            />
          </Box>
        </Stack>
      )}
    </div>
  );
};

export default SegmentationSection;
